import { Injectable, inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
export type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private doc = inject(DOCUMENT);
  private r: Renderer2 = inject(RendererFactory2).createRenderer(null, null);
  private key = 'ui:theme';

  init(theme: 'light' | 'dark') {
    document.body.setAttribute('data-theme', theme);
  }

  apply(t: Theme) {
    localStorage.setItem(this.key, t);
    this.r.setAttribute(this.doc.documentElement, 'data-theme', t);
  }
  
  getTheme(): 'light' | 'dark' {
    return (localStorage.getItem('theme') as 'light' | 'dark') || 'light';
  }

  setTheme(theme: 'light' | 'dark') {
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }
}
